import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

const DefaultSearchInput = ({ search, setSearch, setParams, limit, fullWidth = false }) => {
    const { t } = useTranslation();
    const handleClear = () => {
        setSearch('');
    };

    return (
        <TextField
            autoFocus
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <CloseIcon
                            size="small"
                            sx={{ visibility: search ? 'visible' : 'hidden', cursor: 'pointer' }}
                            onClick={handleClear}
                        />
                    </InputAdornment>
                ),
            }}
            placeholder={t('searchPlaceholder')}
            value={search || ''}
            size="small"
            autoComplete="off"
            onChange={(ev) => {
                if (setParams) {
                    setParams({ page: 0, limit });
                }
                setSearch(ev.target.value);
            }}
            fullWidth={fullWidth}
        />
    );
};
export default DefaultSearchInput;
